import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Form from "../../../common/forms/Form";
import FormInput from "../../../common/forms/FormInput";

import styles from "./UserNote.module.scss";

type Props = {
  memo?: string;
  isMemoEdit: boolean;
  handleMemoEdit: () => void;
  handleMemoUpdate: () => void;
  setMemo: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const UserNote: React.FC<Props> = ({
  memo,
  isMemoEdit,
  handleMemoEdit,
  handleMemoUpdate,
  setMemo,
}) => {
  return (
    <div className={styles["f-userMemo"]}>
      <div className={styles["f-userMemo__header"]}>
        <div>
          <FontAwesomeIcon icon={["far", "file-alt"]} />
          <span>メモ</span>
        </div>
        {isMemoEdit ? (
          <button
            className={styles["save"]}
            type="button"
            onClick={() => handleMemoUpdate()}
          >
            保存
          </button>
        ) : (
          <button
            className={styles["edit"]}
            type="button"
            onClick={() => handleMemoEdit()}
          >
            編集
          </button>
        )}
      </div>
      <div className={styles["f-userMemo__wrapper"]}>
        <Form handler={() => {}}>
          <FormInput
            type="textarea"
            label=""
            name="sonic_memo"
            handler={(value) => {
              if (value !== undefined && typeof value === "string") {
                setMemo(value);
              }
            }}
            disabled={isMemoEdit === true ? false : true}
            initial_value={memo}
          />
        </Form>
      </div>
    </div>
  );
};

export default UserNote;
